import React, { useEffect, useState } from 'react';
import { MessageKeys, useTranslations } from 'next-intl';
import styles from './university-select-bar.module.scss';
import { IDropdownItem } from '../../../models/IDropdownItem';
import Button from '../../atoms/button/button';
import Dropdown from '../../atoms/dropdown/dropdown';
import { ButtonStyleType } from '../../../constants/button-style-type';
import { BrandDropDownItem } from '../../../models/homepage/BrandDropDownItem';
import { ApplicationBranding } from '../../../models/settings';
import colorStyle from '../../../styles/utils/variables.module.scss';

type Props = {
  universities: BrandDropDownItem[];
  countries: IDropdownItem[];
  applicationBranding: ApplicationBranding;
  currentLocale: string;
};

type FilteredUniversities = {
  value: string;
  text: string;
  isNewTemplate?: boolean;
};

export default function UniversitySelectBar({
  universities,
  countries,
  applicationBranding,
  currentLocale,
}: Props) {
  const [translatedCountries, setTranslatedCountries] = useState<IDropdownItem[]>(countries);
  const [filteredUniversities, setFilteredUniversities] = useState<FilteredUniversities[]>([]);
  const [selectedUniversity, setSelectedUniversity] = useState<string>(``);
  const [selectedCountry, setSelectedCountry] = useState<string>(countries[0].value);
  const translate = useTranslations(`Common`);

  useEffect(() => {
    setTranslatedCountries(
      countries.map((c) => ({
        ...c,
        text: translate(`countries.${c.text.toLowerCase()}` as MessageKeys<any, any>),
      })),
    );
    initCountryUniversity(countries[0].value);
  }, []);

  const initCountryUniversity = (country) => {
    setSelectedCountry(country);
    const filterUniversities = universities
      .filter((uni) => uni.country === country)
      .map((uni) => ({
        text: uni.name,
        value: uni.slug,
        isNewTemplate: uni.isNewTemplate,
      }));
    setFilteredUniversities(filterUniversities);
    setSelectedUniversity(filterUniversities[0].value);
  };

  return (
    <>
      {translatedCountries.length ? (
        <div id='university-select-bar' className={styles[`university-bar`]}>
          <div className='container'>
            <div className={`${styles[`university-bar-content`]}`}>
              <div className={'row'}>
                <div className='col-md-4 d-flex align-items-center'>
                  <p className={`mb-3 mb-md-0 ${styles[`h3-label`]}`}>
                    {translate(`homepage.explore-our-unis`)}
                  </p>
                </div>
                <div className='col-md-8 d-md-flex align-items-center'>
                  <div className={`${styles[`university-bar-dropdown-wrapper`]} mb-3 mb-md-0`}>
                    <Dropdown
                      options={translatedCountries}
                      customClass={`${styles[`university-bar-dropdown`]}
                    ${styles[`flag-${selectedCountry}`]}`}
                      ariaLabel='Country dropdown'
                      id='country-dropdown'
                      onChange={(val) => initCountryUniversity(val)}
                    />
                  </div>
                  <div className={`${styles[`university-bar-dropdown-wrapper`]} mb-3 mb-md-0`}>
                    <Dropdown
                      options={filteredUniversities}
                      ariaLabel='University dropdown'
                      id='uni-dropdown'
                      customClass={`${styles[`university-bar-dropdown`]}`}
                      onChange={(val) => setSelectedUniversity(val)}
                    />
                  </div>
                  <Button
                    buttonStyle={ButtonStyleType.Filled}
                    buttonURL={`${currentLocale}/universities/${selectedUniversity}`}
                    activeBackgroundColor={applicationBranding.primaryActiveColor}
                    backgroundColor={applicationBranding.primaryColor}
                    hoverBackgroundColor={applicationBranding.primaryHoverColor}
                    copyColor={colorStyle.white}
                  >
                    {translate(`homepage.view`)}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
